import React from "react";
import Box from "@vapor/react-material/Box";
import Typography from "@vapor/react-extended/ExtendedTypography";
import Divider from "@vapor/react-material/Divider";
import Stack from "@vapor/react-material/Stack";
import { HeaderBarItem } from "./HeaderBarItem";

export type VaporHeaderBarProps = {
  size?: string;
  title: string;
  description?: string;
  /**
   * You can use `breadcrumbs` prop to insert Breadcrumbs logic components. It will be displayed in the last line of thes Title.
   */
  breadcrumbs?: React.ReactNode;
  reduced?: boolean;
  divider?: boolean;
  leftItems?: React.ReactNode[] | React.ReactNode;
  rightItems?: React.ReactNode[] | React.ReactNode;
  titleItems?: React.ReactNode[] | React.ReactNode;
};

export const VaporHeaderBar = (props: VaporHeaderBarProps) => {
  const {
    title,
    description,
    breadcrumbs,
    size,
    reduced = false,
    divider = true,
    leftItems = [],
    rightItems = [],
    titleItems = []
  } = props;
  return (
    <Box
      sx={{
        width: "100%",
        height: size === "small" ? "48px" : reduced ? "56px" : "80px"
      }}
    >
      <Box
        sx={{
          display: "flex",
          // my: size === "small" ? "4px" : reduced ? "6px" : "18px",
          // mx: size === "small" ? "4px" : "9px",
          alignItems: "center",
          bgcolor: "transparent",
          height: size === "small" ? "46px" : reduced ? "54px" : "78px"
        }}
      >
        {leftItems && Array.isArray(leftItems) ? (
          leftItems.map((item, index) => {
            return <HeaderBarItem key={index}>{item}</HeaderBarItem>;
          })
        ) : (
          <HeaderBarItem>{leftItems}</HeaderBarItem>
        )}

        <Box
          sx={{
            flexGrow: 1,
            textAlign: reduced ? "left" : "center",
            alignItems: reduced ? "left" : "center",
            pl: size === "small" ? "8px" : "15px",
            direction: "column",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Stack>
              <Typography
                sx={{
                  padding: 0,
                  lineHeight: 1.5,
                  fontSize: size === "small" ? 16 : description ? 20 : 24
                }}
                variant="titleSmall"
                component={"h1"}
              >
                {title}
              </Typography>

              {description && (
                <Typography
                  sx={{ padding: 0, lineHeight: 1 }}
                  variant="pageDescription"
                  component={"h2"}
                >
                  {description}
                </Typography>
              )}

              {breadcrumbs && (
                <Box sx={{ paddingBottom: reduced ? 2 : 0 }}>{breadcrumbs}</Box>
              )}
            </Stack>
            {titleItems && Array.isArray(titleItems) ? (
              titleItems.map((item, index) => {
                return <HeaderBarItem key={index}>{item}</HeaderBarItem>;
              })
            ) : (
              <HeaderBarItem>{titleItems}</HeaderBarItem>
            )}
          </Box>
        </Box>
        {rightItems && Array.isArray(rightItems) ? (
          rightItems.map((item, index) => {
            return <HeaderBarItem key={index}>{item}</HeaderBarItem>;
          })
        ) : (
          <HeaderBarItem>{rightItems}</HeaderBarItem>
        )}
      </Box>
      {divider && (
        <Divider
          sx={{ height: "2px", backgroundColor: "primary.interactiveDefault" }}
          variant="fullWidth"
        />
      )}
    </Box>
  );
};
